import { render } from "./CometChatGroupDetails.vue?vue&type=template&id=1b5eddc0&scoped=true"
import script from "./CometChatGroupDetails.vue?vue&type=script&lang=js"
export * from "./CometChatGroupDetails.vue?vue&type=script&lang=js"

import "./CometChatGroupDetails.vue?vue&type=style&index=0&id=1b5eddc0&scoped=true&lang=css"

import exportComponent from "../../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b5eddc0"]])

export default __exports__